import {
    GET_OVERRIDE_DETAILS,
    GET_OVERRIDE_DETAILS_SUCCESS,
    GET_OVERRIDE_DETAILS_FAILURE,
    RESET_OVERRIDE_DETAILS,
} from '../actions';

const initialState = {
    loading: false,
    overrideDetails: null,
    statusCode: '',
    statusMessage: '',
};

const overrideDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_OVERRIDE_DETAILS:
            return {
                ...state,
                loading: true,
            };
        case GET_OVERRIDE_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                overrideDetails: action.data || null,
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case GET_OVERRIDE_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                overrideDetails: null,
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case RESET_OVERRIDE_DETAILS:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

export default overrideDetailsReducer;
